// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"IV-z","inlineTitle":"JV-z","sponsoredAdsWrapper":"KV-z","marketplaceRecosWrapper":"LV-z"};